
// // import { useEffect, useRef } from 'react';
// // import { useNavigate } from 'react-router-dom';

// // const useAuth = () => {
// //   const navigate = useNavigate();
// //   const refreshTimeoutRef = useRef(null);

// //   useEffect(() => {
// //     const scheduleRefresh = (token) => {
// //       try {
// //         const decoded = JSON.parse(atob(token.split('.')[1])); 
// //         const expiryTime = decoded.exp * 1000; 
// //         const now = Date.now();

// //         const refreshIn = Math.max(expiryTime - now - 60 * 1000, 5000);

// //         if (refreshTimeoutRef.current) clearTimeout(refreshTimeoutRef.current);

// //         refreshTimeoutRef.current = setTimeout(() => {
// //           refreshToken();
// //         }, refreshIn);
// //       } catch (e) {
// //         console.error('Error decoding access token', e);
// //         logout();
// //       }
// //     };

// //     const refreshToken = async () => {
// //       const storedRefreshToken = localStorage.getItem('refreshToken');
// //       if (!storedRefreshToken) return logout();

// //       try {
// //         const response = await fetch(
// //           'https://salesjet-10097049716.catalystappsail.com/refresh-token',
// //           {
// //             method: 'POST',
// //             headers: { 'Content-Type': 'application/json' },
// //             body: JSON.stringify({ refreshToken: storedRefreshToken }),
// //           }
// //         );

// //         const data = await response.json();

// //         if (response.ok && data.accessToken) {
// //           localStorage.setItem('accessToken', data.accessToken);
// //           scheduleRefresh(data.accessToken);
// //         } else {
// //           logout();
// //         }
// //       } catch (err) {
// //         console.error('Refresh token error', err);
// //         logout();
// //       }
// //     };

// //     const storedAccessToken = localStorage.getItem('accessToken');
// //     if (storedAccessToken) {
// //       scheduleRefresh(storedAccessToken);
// //     } else {
// //       refreshToken();
// //     }

// //     return () => {
// //       if (refreshTimeoutRef.current) clearTimeout(refreshTimeoutRef.current);
// //     };
// //   }, []);

// //   const logout = () => {
// //     localStorage.removeItem('accessToken');
// //     localStorage.removeItem('refreshToken');
// //     navigate('/');
// //   };

// //   return { logout };
// // };

// // export default useAuth;

// // old code 
// import { useEffect, useRef } from 'react';
// import { useNavigate } from 'react-router-dom';

// const useAuth = () => {
//   const navigate = useNavigate();
//   const refreshTimeoutRef = useRef(null);

//   useEffect(() => {
//     const scheduleRefresh = (token) => {
//       try {
//         const decoded = JSON.parse(atob(token.split('.')[1])); 
//         console.log('[Auth] Decoded access token:', decoded);
//         const expiryTime = decoded.exp * 1000; 
//         console.log('[Auth] Token expires at:', new Date(expiryTime).toLocaleString());
//         const now = Date.now();

//         const refreshIn = Math.max(expiryTime - now - 60 * 1000, 5000);
       

//         console.log(
//           `[Auth] Scheduling token refresh in ${(refreshIn / 1000).toFixed(1)} seconds`
//         );

//         if (refreshTimeoutRef.current) clearTimeout(refreshTimeoutRef.current);

//         refreshTimeoutRef.current = setTimeout(() => {
//           console.log("[Auth] Refresh timeout triggered, calling refreshToken()");
//           refreshToken();
//         }, refreshIn);
//       } catch (e) {
//         console.error('Error decoding access token', e);
//         logout();
//       }
//     };

//     const refreshToken = async () => {
//       const storedRefreshToken = localStorage.getItem('refreshToken');
//       if (!storedRefreshToken) {
//         console.warn('[Auth] No refresh token found → logging out');
//         return logout();
//       }

//       console.log('[Auth] Using refresh token to get a new access token...');

//       try {
//         const response = await fetch(
//           'https://salesjet-10097049716.catalystappsail.com/refresh-token',
//           {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({ refreshToken: storedRefreshToken }),
//           }
//         );

//         const data = await response.json();

//         if (response.ok && data.accessToken) {
//           console.log('[Auth] New access token received, rescheduling refresh');
//           localStorage.setItem('accessToken', data.accessToken);
//           scheduleRefresh(data.accessToken);
//         } else {
//           console.error('[Auth] Refresh failed, logging out', data);
//           logout();
//         }
//       } catch (err) {
//         console.error('[Auth] Refresh token error', err);
//         logout();
//       }
//     };

//     const storedAccessToken = localStorage.getItem('accessToken');
//     if (storedAccessToken) {
//       console.log('[Auth] Found stored access token, scheduling refresh');
//       scheduleRefresh(storedAccessToken);
//     } else {
//       console.log('[Auth] No access token found, trying refresh');
//       refreshToken();
//     }

//     return () => {
//       if (refreshTimeoutRef.current) clearTimeout(refreshTimeoutRef.current);
//     };
//   }, []);

//   const logout = () => {
//     console.warn('[Auth] Logging out, clearing tokens');
//     localStorage.removeItem('accessToken');
//     localStorage.removeItem('refreshToken');
//     navigate('/');
//   };

//   return { logout };
// };

// export default useAuth;

// // same code with console logs
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const useAuth = () => {
  const navigate = useNavigate();
  const refreshTimeoutRef = useRef(null);

  useEffect(() => {
    const scheduleRefresh = (token) => {
      try {
        const decoded = JSON.parse(atob(token.split('.')[1]));
        const expiryTime = decoded.exp * 1000;
        const issuedAt = decoded.iat * 1000;
        const now = Date.now();

        const lifetime = expiryTime - issuedAt; // total token life
        let refreshBefore = lifetime * 0.1; // default 10% before expiry

        // If token life is >= 1 hour, refresh 5 minutes before expiry
        if (lifetime >= 60 * 60 * 1000) {
          refreshBefore = 5 * 60 * 1000;
        }

        const refreshIn = Math.max(expiryTime - now - refreshBefore, 5000);

        console.log(
          `[Auth] Token lifetime: ${(lifetime / 1000 / 60).toFixed(
            1
          )} mins | Refreshing in ${(refreshIn / 1000 / 60).toFixed(2)} mins`
        );

        if (refreshTimeoutRef.current) clearTimeout(refreshTimeoutRef.current);

        refreshTimeoutRef.current = setTimeout(() => {
          console.log('[Auth] Refresh timeout triggered, calling refreshToken()');
          refreshToken();
        }, refreshIn);
      } catch (e) {
        console.error('Error decoding access token', e);
        logout();
      }
    };

    const refreshToken = async () => {
      const storedRefreshToken = localStorage.getItem('refreshToken');
      if (!storedRefreshToken) {
        console.warn('[Auth] No refresh token found → logging out');
        return logout();
      }

      console.log('[Auth] Using refresh token to get a new access token...');

      try {
        const response = await fetch(
          'https://salesjet-10097049716.catalystappsail.com/refresh-token',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ refreshToken: storedRefreshToken }),
          }
        );

        const data = await response.json();

        if (response.ok && data.accessToken) {
          console.log('[Auth] New access token received, rescheduling refresh');
          localStorage.setItem('accessToken', data.accessToken);
          scheduleRefresh(data.accessToken);
        } else {
          console.error('[Auth] Refresh failed, logging out', data);
          logout();
        }
      } catch (err) {
        console.error('[Auth] Refresh token error', err);
        logout();
      }
    };

    const storedAccessToken = localStorage.getItem('accessToken');
    if (storedAccessToken) {
      console.log('[Auth] Found stored access token, scheduling refresh');
      scheduleRefresh(storedAccessToken);
    } else {
      console.log('[Auth] No access token found, trying refresh');
      refreshToken();
    }

    return () => {
      if (refreshTimeoutRef.current) clearTimeout(refreshTimeoutRef.current);
    };
  }, []);

  const logout = () => {
    console.warn('[Auth] Logging out, clearing tokens');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    navigate('/');
  };

  return { logout };
};

export default useAuth;
